import { app } from '../../../app';

app.factory('UserEmailsService', UserEmailsService);

/** @ngInject */
function UserEmailsService($resource) {
    return $resource('app/rest/emails/:id', {
        id : '@id'
    }, {
        'getActiveEmails' : {
            method : 'GET',
            url : 'app/rest/emails?status=active',
            isArray : true
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/emails.service.js